export const getLastVariableData = (state) => state.variables.lastData;

export const getVariablesImportedAt = (state) => state.variables.variablesImportedAt;

export const getImportErrors = (state) => state.variables.importErrors;
